exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ShareDialog-8b24db58 .shareIcons-8f6e9e67{display:flex;justify-content:space-around;padding-bottom:30px;margin-left:30px;margin-right:30px}.ShareDialog-8b24db58 .shareIcons-8f6e9e67 .icon-4e3af556{flex:0 0 auto;font-size:40px;color:#fff}.ShareDialog-8b24db58 .shareIcons-8f6e9e67 .icon-4e3af556:visited,.ShareDialog-8b24db58 .shareIcons-8f6e9e67 .icon-4e3af556:active,.ShareDialog-8b24db58 .shareIcons-8f6e9e67 .icon-4e3af556:hover{text-decoration:none}.ShareDialog-8b24db58 .ctaIcon-6072e377{margin-top:-2px;margin-right:5px}\n", ""]);

// Exports
exports.locals = {
	"ShareDialog": "ShareDialog-8b24db58",
	"shareIcons": "shareIcons-8f6e9e67",
	"icon": "icon-4e3af556",
	"ctaIcon": "ctaIcon-6072e377"
};